import { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { googleSession } from '../lib/api';
import { setToken, setUser } from '../lib/auth';
import { toast } from 'sonner';
import { Loader2 } from 'lucide-react';

export default function AuthCallback() {
  const navigate = useNavigate();
  const processed = useRef(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = window.location.hash || '';
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? decodeURIComponent(match[1]) : null;

    if (!sessionId) {
      navigate('/login', { replace: true });
      return;
    }

    (async () => {
      try {
        const res = await googleSession(sessionId);
        setToken(res.data.token);
        setUser(res.data.user);
        // clear the sensitive fragment
        window.history.replaceState({}, '', '/auth/callback');
        toast.success('Welcome!');
        navigate('/home', { replace: true });
      } catch (err) {
        const msg = err.response?.data?.detail || 'Google sign-in failed. Please try again.';
        setError(msg);
        toast.error(msg);
        setTimeout(() => navigate('/login', { replace: true }), 2500);
      }
    })();
  }, [navigate]);

  return (
    <div
      className="min-h-screen flex flex-col items-center justify-center p-6 text-center"
      style={{ background: 'linear-gradient(135deg, #EFF6FF 0%, #ECFDF5 100%)' }}
      data-testid="auth-callback"
    >
      {!error ? (
        <>
          <Loader2 size={40} className="animate-spin text-blue-600 mb-4" />
          <p className="text-slate-600 font-medium">Signing you in…</p>
        </>
      ) : (
        <>
          <p className="text-slate-800 font-semibold mb-1">Couldn't sign you in</p>
          <p className="text-slate-500 text-sm max-w-sm">{error}</p>
          <p className="text-slate-400 text-xs mt-3">Redirecting to login…</p>
        </>
      )}
    </div>
  );
}
